import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import VerifyAccount from "../../Template/Auth/VerifyAccount/VerifyAccount";

function VerifyAccountPage() {
  const navigate = useNavigate();

  return <VerifyAccount />;
}

export default VerifyAccountPage;
